import { IFootballLiveScore } from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { LiveScoreQuery } from "../types";
import { isValidLiveScoreQuery } from "./typeguards";
import { intcmpMap } from '../../../utils/intcmp';
import { CreateLiveScoreInputSchema } from 'appsync';

export default (obj: LiveScoreQuery): IFootballLiveScore => {
  if (isValidLiveScoreQuery(obj)) {
    CreateLiveScoreInputSchema().parse(obj.data.getLiveScore, {reportInput: true});
    const { previousDay, currentDay, nextDay } = obj.data.getLiveScore;

    return {
      currentDay: (currentDay ?? []).filter(Boolean) as IFootballLiveScore["currentDay"],
      nextDay: (nextDay ?? []).filter(Boolean) as IFootballLiveScore["nextDay"],
      previousDay: (previousDay ?? []).filter(Boolean) as IFootballLiveScore["previousDay"],
      trackingData: intcmpMap.liveScore,
    };
  }

  throw new WidgetError<ErrorName>({
    name: "NO_VALID_DATA",
    message: "Invalid transformer input, Error in LiveScoreQuery object",
    data: obj,
  });
};
